import { Injectable } from '@angular/core';
import { AlertButton, AlertController, AlertOptions } from '@ionic/angular';

/**
 * Confirm alert option interface.
 */
export interface ConfirmAlertOptions {
  message: AlertOptions['message'];
  header?: AlertOptions['header'];
  subHeader?: AlertOptions['subHeader'];
  buttons: [ConfirmAlertButton, ConfirmAlertButton?];
  backdropDismiss?: AlertOptions['backdropDismiss'];
}

/**
 * Confirm alert button option interface.
 */
export interface ConfirmAlertButton {
  text: AlertButton['text'];
  handler?: AlertButton['handler'];
}

/**
 * The purpose of this service is to show prompts such as alerts.
 */
@Injectable({
  providedIn: 'root',
})
export class PromptsService {
  constructor(private alertCtrl: AlertController) {}

  /**
   * Method to show confirm alert.
   *
   * @param options - Alert options.
   */
  public async showConfirmAlert(options: ConfirmAlertOptions): Promise<void> {
    const alert = await this.alertCtrl.create(options);

    await alert.present();
  }

  /**
   * Method to shown default confirm alert.
   *
   * @param message - Message to be shown.
   * @param okHandler - Default handler for 'ok' action.
   * @param backdrop - The alert will be dismissed when the backdrop is clicked (default is true).
   */
  public async showBasicConfirmAlert(
    message: ConfirmAlertOptions['message'],
    okHandler: ConfirmAlertButton['handler'],
    backdrop: ConfirmAlertOptions['backdropDismiss'] = true,
  ): Promise<void> {
    // default options
    const defaultConfirmOptions: ConfirmAlertOptions = {
      header: 'Confirmation',
      message,
      buttons: [{ text: 'Cancel' }, { text: 'Ok', handler: okHandler }],
      backdropDismiss: backdrop,
    };

    await this.showConfirmAlert(defaultConfirmOptions);
  }
}
